import { withChartLayout } from 'components/common';
import GastrointestinalInterventions from 'components/features/chart/system-nursing-interventions/gastrointestinal-interventions/GastrointestinalInterventions';

const GastrointestinalInterventionsPage = withChartLayout('Gastrointestinal Interventions')(GastrointestinalInterventions);
export default GastrointestinalInterventionsPage;
